import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CourseSelection } from '../select-course-dialog/course-selection.service';

@Component({
    selector: 'app-predefined-pathway-course-list',
    templateUrl: './course-list.component.html',
    styleUrls: ['./course-list.component.css'],
    imports: [TranslateModule, ButtonModule, CdkDropList, CdkDrag],
})
export class CourseListComponent {
    readonly courses = input.required<CourseSelection[]>();

    readonly add = output<void>();
    readonly remove = output<string>();
    readonly reorder = output<CourseSelection[]>();

    moveCourse(index: number, direction: -1 | 1): void {
        const courses = [...this.courses()];
        moveItemInArray(courses, index, index + direction);
        this.reorder.emit(courses);
    }

    onDrop(event: CdkDragDrop<CourseSelection[]>): void {
        const courses = [...this.courses()];
        moveItemInArray(courses, event.previousIndex, event.currentIndex);
        this.reorder.emit(courses);
    }
}
